/* 🤖 this file was generated by script */
export const wiconHelpCircle = {
  name: 'help_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3m.08 4h.01M22 12a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
